import { Component, ChangeDetectionStrategy } from '@angular/core';

import { VersionPolicyService } from './version-policy.service';

@Component({
    selector: 'app-version-gate-dialog',
    templateUrl: './version-gate-dialog.component.html',
    styleUrls: ['./version-gate-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VersionGateDialogComponent {
  readonly state = this.versionPolicyService.state;

  constructor(public versionPolicyService: VersionPolicyService) {}
}
